/**
 * Contenus publics du site WOTE (version client)
 * Ne pas y placer de textes internes RH / equipe.
 */

export const company = {
  name: 'WOTE',
  tagline: "Au delà de l'imagination!",
  location: 'Kinshasa, RDC',
};

export const presentation = {
  intro:
    "WOTE est une startup informatique qui accompagne les étudiants, les particuliers et les entreprises dans la conception, le développement et l'optimisation de leurs solutions technologiques.",
  complement:
    'Nous concevons également nos propres solutions pour simplifier le quotidien du grand public et répondre à des besoins concrets.',
};

export const mission = {
  title: 'Notre Mission',
  text:
    'Rendre la technologie accessible, utile et performante pour tous. Nous transformons des idées en solutions concrètes, efficaces et durables, avec un impact réel sur les utilisateurs.',
  complement:
    'Que vous soyez étudiant, entrepreneur ou entreprise, WOTE vous accompagne de la conception à la mise en production.',
};

export const vision = {
  title: 'Notre Vision',
  paragraphs: [
    'Faire de WOTE une référence technologique majeure, née d\'Afrique, capable de créer des solutions innovantes et adaptées aux réalités locales comme internationales.',
    'Nous visons une entreprise tech de niveau international qui repousse les limites du possible — au-delà de l\'imagination.',
  ],
};

export const values = [
  {
    id: 'innovation',
    title: 'Innovation continue',
    description: 'Explorer de nouvelles approches et technologies pour mieux servir nos clients.',
  },
  {
    id: 'rigueur',
    title: 'Rigueur technique',
    description: 'Qualité, fiabilité et bonnes pratiques dans chaque livrable.',
  },
  {
    id: 'creativite',
    title: 'Créativité',
    description: 'Des solutions originales, pensées pour répondre à de vrais besoins.',
  },
  {
    id: 'apprentissage',
    title: 'Apprentissage constant',
    description: 'Veille technologique et amélioration continue de nos méthodes.',
  },
  {
    id: 'impact',
    title: 'Impact utilisateur',
    description: 'Chaque projet et chaque produit doit créer une valeur mesurable.',
  },
];

export const whyWote = [
  {
    title: 'Expertise technique',
    text: 'Développement web, desktop et mobile avec des technologies modernes.',
  },
  {
    title: 'Accompagnement sur mesure',
    text: 'Étudiants, particuliers et entreprises : un suivi adapté à chaque profil.',
  },
  {
    title: 'Services et produits WOTE',
    text: 'Projets clients et solutions maison conçues pour le grand public.',
  },
  {
    title: 'Ancrage local, ambition globale',
    text: 'Basés à Kinshasa, nous construisons des solutions pour l\'Afrique et au-delà.',
  },
];

export const servicesList = [
  {
    id: 'developpement',
    title: 'Développement',
    description:
      'Conception et réalisation d\'applications web, desktop et mobiles performantes.',
    features: [
      'Applications web (React, Next.js, Laravel, etc.)',
      'Applications desktop et mobiles',
      'Solutions sur mesure et évolutives',
      'Optimisation et maintenance',
    ],
  },
  {
    id: 'accompagnement',
    title: 'Accompagnement de projets',
    description:
      'Support complet pour vos projets informatiques, académiques ou professionnels.',
    features: [
      'Projets de fin d\'études (TFE, TFC, TP)',
      'Orientation et méthodologie pour étudiants',
      'Projets pour particuliers et entreprises',
      'Suivi de la conception à la livraison',
    ],
  },
  {
    id: 'formation',
    title: 'Formation',
    description:
      'Montée en compétences en développement et technologies modernes.',
    features: [
      'Formation en développement web et mobile',
      'Ateliers techniques pratiques',
      'Accompagnement pédagogique personnalisé',
      'Transfert de compétences pour équipes',
    ],
  },
  {
    id: 'conseil',
    title: 'Conseil IT & stratégie',
    description:
      'Conseil stratégique pour optimiser votre transformation digitale.',
    features: [
      'Audit et analyse de systèmes',
      'Stratégie de transformation digitale',
      'Optimisation des processus métier',
      'Conseils en sécurité informatique',
    ],
  },
];

export const productsList = [
  {
    id: 'badepenses',
    name: 'BaDepenses',
    category: 'Produit WOTE — Application web',
    tagline: 'Gérez vos dépenses simplement',
    description:
      'Solution WOTE pour suivre, organiser et mieux maîtriser vos dépenses au quotidien, avec une interface simple et accessible.',
    url: 'https://badepenses.wotes.org',
    status: 'Disponible',
    image: '/logo3.png',
  },
];

export const footerServices = [
  'Développement',
  'Accompagnement de projets',
  'Formation',
  'Conseil IT & stratégie',
];
